import {makeReactContext} from 'lib/makeReactContext';

export interface HandlesContextValue {
  handlesInUse: Array<string>;
}

/** Context to keep track of which handles are currently connected via at least one edge */
export const HandlesContext = makeReactContext<HandlesContextValue>(
  () => ({
    handlesInUse: [],
  }),
  'HandlesContext'
);
